<template>
    <div class="media-list__item media-list__item-video" @click="openDialog">
        <video class="media-list__player">
            <source :src="url"/>
        </video>
    </div>
</template>

<script>
  import Base from './base';

  export default {
    extends: Base,
  }
</script>
